import React from 'react'
import dynamic from 'next/dynamic'

const Layout1 = dynamic(() => import('./layout1'));
const Fullpic = dynamic(() => import('./fullpic'));
const LAYOUTS = {
    FULLPIC: 'FullPic',
    LAYOUT1: 'Layout1' 
}

const BannerHome = (props) => {
    const { layout } = props;

    switch(layout){
        case LAYOUTS.FULLPIC: return (<Fullpic {...props} />);
        case LAYOUTS.LAYOUT1:
        default: 
            return (
                <Layout1 {...props} />
            )
    }
}

export default BannerHome;
